<span *ngIf="!feature.properties?.hideLabel">
                <span>{{feature.name}}</span> <br/>
              </span>

<div *ngIf="!!feature.properties.description" class="feature-description">
  <span [innerHTML]="feature.properties.description | safeHtml"></span>
</div>
